import { render, staticRenderFns } from "./ModalExportGlobal.vue?vue&type=template&id=2e871a60&"
import script from "./ModalExportGlobal.vue?vue&type=script&lang=js&"
export * from "./ModalExportGlobal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports